// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorPlanListRequestModel {
    static getAttributeTypeMap() {
        return PayorPlanListRequestModel.attributeTypeMap;
    }
}
PayorPlanListRequestModel.discriminator = undefined;
PayorPlanListRequestModel.attributeTypeMap = [
    {
        "name": "payorPlanIds",
        "baseName": "payorPlanIds",
        "type": "Array<number>"
    }
];
//# sourceMappingURL=payorPlanListRequestModel.js.map